import Card from '@/components/blacktel/cards/iq-card'
import Loader from '@/components/blacktel/loader/Loader'
import WidgetLoader from '@/components/blacktel/loader/WidgetLoader'
import CallLoader from '@/components/blacktel/loader/CallLoader'
import DeleteInputConfirm from '@/components/blacktel/modal/delete-input-confirm.vue'
import DeleteConfirmation from '@/components/blacktel/modal/delete-confirmation.vue'
import IncomingCall from '@/components/blacktel/modal/incoming-call.vue'
import ActivityTooltip from '@/components/blacktel/cards/activity-tooltip.vue'
import Callouts from '@/components/blacktel/callouts/callouts.vue'
import Notification from '@/components/blacktel/notification/Notification.vue'
import Svg1 from '@/components/blacktel/svg/svg1'
import Svg2 from '@/components/blacktel/svg/svg2'
import Svg3 from '@/components/blacktel/svg/svg3'
import Svg4 from '@/components/blacktel/svg/svg4'
import Svg5 from '@/components/blacktel/svg/svg5'
import Svg6 from '@/components/blacktel/svg/svg6'
import Svg7 from '@/components/blacktel/svg/svg7'
import ActivityCard from '@/components/blacktel/cards/activity-card.vue'

/* eslint-disable vue/multi-word-component-names */
export default {
  install: (app) => {
    app.component('iq-card', Card)
    app.component('Loader', Loader)
    app.component('WidgetLoader', WidgetLoader)
    app.component('CallLoader', CallLoader)
    app.component('activity-card', ActivityCard)
    app.component('delete-input-confirm', DeleteInputConfirm)
    app.component('delete-confirmation', DeleteConfirmation)
    app.component('incoming-call', IncomingCall)
    app.component('activity-tootip', ActivityTooltip)
    app.component('callouts', Callouts)
    app.component('Notification', Notification)
    app.component('svg1', Svg1)
    app.component('svg2', Svg2)
    app.component('svg3', Svg3)
    app.component('svg4', Svg4)
    app.component('svg5', Svg5)
    app.component('svg6', Svg6)
    app.component('svg7', Svg7)
  }
}
